import { createApp } from 'vue'
import App from '@/App.vue'
import { registerPlugins } from '@core/utils/plugins'
import store from '@/store'
import { router } from '@/plugins/1.router'
import { setupInterceptors } from '@/api/interceptor/interceptor.js'
import { setupChunkErrorHandler } from '@/plugins/chunk-error-handler'
import { setupVersionCheck } from '@/plugins/version-check'
import { DEV_MODE } from '@/config/dev-mode'

// Styles
import '@core/scss/template/index.scss'
import '@styles/styles.scss'

import axios from 'axios'

axios.defaults.baseURL = import.meta.env.VITE_APP_GW_URL // 개발서버 API 경로

// Create vue app
const app = createApp(App)

// Register plugins
registerPlugins(app)

// Vuex store (router는 registerPlugins에서 자동 등록)
app.use(store)

// 배포 버전 감지 설정 (새 버전 감지 시 다음 라우트 이동을 풀 로드로 전환)
const teardownVersionCheck = setupVersionCheck(router)

// 청크 로드 에러 핸들러 설정 (라우터 등록 직후, mount 전에 설정해야 beforeEach가 제대로 동작)
const teardownChunkErrorHandler = setupChunkErrorHandler(router)

// Setup Axios interceptors
const teardownInterceptors = setupInterceptors(router)

// 디버그 모드에서 [Vue warn] 메시지 숨기고 싶을 때 활성화
app.config.warnHandler = () => {};

// Mount vue app
app.mount('#app')

if (import.meta.hot) {
  import.meta.hot.accept()
  import.meta.hot.dispose(() => {
    teardownInterceptors?.()
    teardownChunkErrorHandler?.()
    teardownVersionCheck?.()
    app.unmount()
  })
}
